import { render, staticRenderFns } from "./w-agent-form.vue?vue&type=template&id=4579d24d"
import script from "./w-agent-form.vue?vue&type=script&lang=js"
export * from "./w-agent-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports